import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DiagnosticCheckService } from '../diagnostic-check/services/diagnostic-check.service';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Component({
  selector: 'vm-place-remote-order-shell',
  template: `
    <ng-container>
      <vm-strapi-page-shell [strapiUID]="strapiUID" *ngIf="strapiUID && showArticle"></vm-strapi-page-shell>
    </ng-container>
  `,
})
export class PlaceRemoteOrderShellComponent implements OnInit {
  strapiUID = null;
  tvBoxTypes = [];
  showArticle = false;

  private http: HttpClient = inject(HttpClient);
  private diagnosticsService = inject(DiagnosticCheckService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  ngOnInit() {
    this.placeOrder().subscribe(
      () => {
        this.tvBoxTypes = this.diagnosticsService.getTVBoxTypes();
        if (this.tvBoxTypes.includes('tivo') || this.tvBoxTypes.includes('v6')) {
          this.strapiUID = 'dc_order-tv-remote-success-v6-tivo';
        } else {
          this.strapiUID = 'dc_order-tv-remote-success-360-stream';
        }
        this.showArticle = true;
      },
      (error) => {
        console.error('Error placing tv remote order:', error);
        this.router.navigate(['../api-failure'], { relativeTo: this.route });
      }
    );
  }

  placeOrder() {
    const workOrderType = 'remoteReplacement';
    const payload = {
      workOrderType,
    };
    const apiURL = `${environment?.gcp?.baseUrl}${environment.gcp.bookingAnEngineer.workOrder}`;
    return this.http.post(apiURL, payload).pipe(
      map((results: any) => {
        return results;
      })
    );
  }
}
